export const AUTH_CHECK = 'AUTH_CHECK'
export const AUTH_SET_DATA = 'AUTH_SET_DATA'
export const AUTH_REQUEST = 'AUTH_REQUEST'
export const AUTH_SUCCESS = 'AUTH_SUCCESS'
export const AUTH_ERROR = 'AUTH_ERROR'
export const AUTH_LOGOUT = 'AUTH_LOGOUT'
